
import { Component, Vue } from 'nuxt-property-decorator'

@Component({ name: 'CircleXmarkSolid' })
export default class CircleXmarkSolid extends Vue {}
